<template>
  <div>
    <div class="cs-header">
      <el-row>
        <el-col :span="8" class="cs-header-left">
          <div class="cs-logo">
            <div class="cs-logo-container">
              <img src="@/assets/logo.png">
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <span>&nbsp;</span>
        </el-col>
        <el-col :span="8" class="cs-header-right">
          <span>&nbsp;</span>
        </el-col>
      </el-row>
    </div>
    <div class="cs-content">
      <div class="cs-content-body">
        <el-row class="cs-contentContainer">
          <el-col :span="12" class="cs-contentContainer-loginLeft">
            <div>&nbsp;</div>
          </el-col>
          <el-col :span="12" class="cs-fullHeight cs-contentContainer-loginMiddle">
            <div class="cs-fullHeight-content cs-contentContainer-loginMiddle-loginWindow">
              <el-form :model="loginForm" :rules="rules" ref="loginForm">
                <div>
                  <el-row>
                    <el-col :span="24" class="cs-contentContainer-loginMiddle-loginWindow-topLine">
                    </el-col>
                  </el-row>
                  <el-row class="cs-login-content">
                    <el-col :span="24" class="cs-login-content">
                      <div class="grid-content">
                        <el-row class="el-form-control">
                          <el-col :span="0"></el-col>
                          <el-col :span="24" class="cs-login-content-title">
                            速成学员登录
                          </el-col>
                        </el-row>
                        <el-row class="el-form-control">
                          <el-col :span="0"></el-col>
                          <el-col :span="24">
                            <div class="user-avatar--circle">
                              <div class="block">
                                <el-avatar :size="94" :src="require('@/assets/profile.png')"></el-avatar>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                        <el-row class="el-form-control">
                          <el-col :span="0"></el-col>
                          <el-col :span="24">
                            <el-form-item prop="name" class="center">
                              <el-input @change='checkAllInputs' placeholder="速成用户账号" v-model="loginForm.name" maxlength="11" class="login_input"
                                @focus='onFocusName'></el-input>
                              <div class="el-form-item__error" v-if="showError">
                                {{ errorMessage }}
                              </div>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row class="el-form-control">
                          <el-col :span="0"></el-col>
                          <el-col :span="24">
                            <el-form-item prop="password" class="center">
                              <el-input @keyup.enter.native="login" @change='checkAllInputs' placeholder="账号密码" class="login_input" type="password"
                                v-model="loginForm.password" @focus='onFocusPwd'>
                              </el-input>
                              <div class="el-form-item__error" v-if="showErrorWrongPwd">
                                *密码错误
                              </div>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row class="el-form-control">
                          <el-col :span="0"></el-col>
                          <el-col :span="24" class="center text-center">
                            <el-button v-bind:type="btnClass" @click="login" class="el-btn-login">登 录</el-button>
                          </el-col>
                        </el-row>
                        <el-row class="el-form-control reg-container">
                          <el-col :span="0"></el-col>
                          <el-col :span="24">
                            <el-button type="text" @click="forgotPassword" class="bottom-btn">忘记密码?</el-button>
                            <el-button type="text" @click="goRegister" class="bottom-btn">注册</el-button>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </el-col>
          <el-dialog title="找回密码" :center="true" :close-on-click-modal="false" :visible.sync="forgotPasswordDialogVisibe" top="10vh">
            <password-editor :type="'forgotPassword'" v-on:closeEditor="onCloseEditor"></password-editor>
          </el-dialog>
          <el-dialog v-if="wechatLoginVisible" :title="wechatTitle" :center="true" :close-on-click-modal="false" :visible.sync="wechatLoginVisible" top="8vh">
            <wechartLogin :action="wechatAction" @success="onWechartLoginSuccess" @fail="onWechartLoginFailed"></wechartLogin>
          </el-dialog>
        </el-row>
      </div>
    </div>
    <el-row class="cs-mobile-footer backgroud-white text-center">
      <el-col>
        <footer>
          @{{currentYear}} 版权归速成教育所有
        </footer>
      </el-col>
    </el-row>
  </div>
</template>


<style lang="scss" scoped>
.cs-contentContainer {
  height: 100%;
  overflow: hidden;
}

.center {
  display: table;
  margin: 0 auto !important;
}

.text-center {
  text-align: center;
}

/deep/ .el-form-item__error {
  margin-left: 200px;
  padding-top: 0px;
  margin-top: -28px;
}

.user-avatar--circle {
  display: table;
  margin: 20px auto;
}

.reg-container {
  padding: 23px;
  .bottom-btn {
    margin: 25px 44px;
    font-size: 12px;
    color: #1c62c3;
    text-decoration: underline;
  }
}

.cs-login-content-title {
  color: #000000;
  font-size: 20px;
  text-align: center;
}

.el-form-item {
  margin-bottom: 0px;
}

.el-btn-login {
  border-radius: 30px;
  width: 315px;
  height: 55px !important;
  font-size: 14px;
  color: white;
  background-color: #006bb4;
  margin-top: 28px;
  border: 0;
}

.el-btn-login:hover {
  background-color: #2957a2;
}

.errorMessageContainer {
  padding-top: 3px;
  min-height: 28px;
}

.el-form-control {
  margin-bottom: 0px;
}

.cs-login-bottom {
  height: 60px;
  footer {
    line-height: 60px;
  }
}

.cs-login-foot {
  .el-form-control {
    margin-bottom: 0px;
  }
  padding-bottom: 4px;
}

.grid-content {
  display: table;
  margin: 0 auto;
  .cs-login-register {
    display: none;
  }
}

.cs-login-content {
  padding-top: 15px;
}
</style>

<script>
import { userLogin, validateToken } from "../service/user.service";
import passwordEditor from "../components/passwordEditor";
import wechartLogin from "../components/common/wechartLogin";
import { getWeChatConfig } from "../service/common.service";

import {
  setStore,
  saveUserInStore,
  getStore,
  compileStr,
  saveUserWechatPassInStore,
  clearUserInStore,
  generateVisitorId
} from "../config/mUtils";
import global_ from "../core/global";
export default {
  data() {
    return {
      currentYear: 2020,
      size: "large",
      user_student_hasWechat: false,
      wechatLoginVisible: false,
      wechatTitle: "绑定微信账号",
      wechatAction: "binding",
      global: global_,
      forgotPasswordDialogVisibe: false,
      showError: false,
      showErrorWrongPwd: false,
      errorMessage: "",
      btnClass: "info",
      loginForm: {
        name: "", //用户名
        password: "",
        loginType: global_.loginType.student.name,
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            min: 0,
            max: 11,
            message: "最大长度在为11个字符",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    passwordEditor,
    wechartLogin,
  },
  created() {
    this.currentYear = new Date().getFullYear();
    this.validateUserLogin();

    //测试 generateVisitorId
    this.$nextTick(async () => {
      let visitorId = await generateVisitorId();
      //console.log("login created:", visitorId);
    });
  },
  methods: {
    setWeChatConfig(isLogin) {
      getWeChatConfig().then((result) => {
        if (!!result && result.success) {
          let configureStr = compileStr(JSON.stringify(result.data));
          setStore("weChatConfig", configureStr);
          if (result.data.Enable){
            this.checkWechat(isLogin);
          }else{
            this.afterLogin();
          }
        }
      });
    },
    checkWechat(isLogin) {
      if (!this.USERMANAGER.isStudent) {
        this.errorMessage = "当前登陆用户不是学生";
        this.showError = true;
        return;
      }

      let user_student_hasWechat = getStore("user_student_hasWechat");
      if (user_student_hasWechat == "1") {
        this.wechatTitle = "验证微信";
        this.wechatAction = "validation";
      } else {
        this.wechatTitle = "绑定微信账号";
        this.wechatAction = "binding";
      }
      this.wechatLoginVisible = true;
    },
    onWechartLoginSuccess() {
      setTimeout(() => {
        this.wechatLoginVisible = false;
        if (this.wechatAction == "binding"){
          setStore("user_student_hasWechat", 1);
        }
        saveUserWechatPassInStore();
        this.afterLogin();
      }, 2000);
    },
    onWechartLoginFailed(){
      clearUserInStore();
      this.wechatLoginVisible = false;
    },
    validateUserLogin() {
      let token = getStore("auth_token");
      let role = getStore("user_role");
      if (token && role) {
        validateToken().then((result) => {
          if (!!result && result.success) {
            this.afterLogin();
            // if (this.global.wechatEnable) {
            //   this.setWeChatConfig(false);
            // } else {
            //   this.afterLogin();
            // }
          }
        });
      }
    },
    afterLogin() {
      this.$emit("logged-event", true);
      let user_student_enable = getStore("user_student_enable");
      let user_student_hasStudentCourseNumber = getStore(
        "user_student_hasStudentCourseNumber"
      );

      if (!this.USERMANAGER.isStudent) {
        this.errorMessage = "当前登陆用户不是学生";
        this.showError = true;
        return;
      }

      let path = "/studentLanding";
      let user_student_studentInProgressWorkflowCount = getStore(
        "user_student_studentInProgressWorkflowCount"
      );
      if (user_student_studentInProgressWorkflowCount){
        user_student_studentInProgressWorkflowCount = parseInt(user_student_studentInProgressWorkflowCount);
      }
      if (user_student_studentInProgressWorkflowCount> 0){
        path = "/addCollectFees/autonomousList";
      }

      if (user_student_enable == "0") {
        this.$router.push(path);
        return;
      }

      if (user_student_hasStudentCourseNumber == "1") {
        this.$router.push(path);
      } else {
        this.$router.push(path);
      }


    },
    //发送登录信息
    async login() {
      if (!!this.$refs["loginForm"]) {
        let isValid = true;
        this.$refs["loginForm"].validate((valid) => {
          if (valid) {
          } else {
            isValid = false;
          }
        });
        if (!isValid) {
          return false;
        }
        let result = await userLogin(
          this.loginForm.name,
          this.loginForm.password,
          this.loginForm.loginType
        );
        if (result) {
          if (!result.success) {
            this.errorMessage = result.message;
            if (this.errorMessage === "密码错误") {
              this.loginForm.password = "";
              this.showErrorWrongPwd = true;
            } else {
              this.loginForm.name = "";
              this.showError = true;
            }
          } else {   
            saveUserInStore(result.data); 
          
            if (this.global.wechatEnable) {
              this.setWeChatConfig(true);
            } else {
              this.afterLogin();
            }
          }
        }
      }
    },
    goRegister() {
      this.$router.push("/register");
    },
    checkAllInputs() {
      if (!!this.loginForm.name && !!this.loginForm.password) {
        this.btnClass = "primary";
      } else {
        this.btnClass = "info";
      }
    },
    forgotPassword() {
      this.forgotPasswordDialogVisibe = true;
    },
    onCloseEditor(type) {
      if (type === "password") {
        this.forgotPasswordDialogVisibe = false;
      }
    },
    onFocusName(event) {
      if (this.showError) {
        this.showError = false;
      }
    },
    onFocusPwd(event) {
      if (this.showErrorWrongPwd) {
        this.showErrorWrongPwd = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/page/login.vue